import { Dispatch, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, OTPStep } from '@unified-checkout/design-system';
import { useEnterKeyPress } from '@app/dashboard/hooks/useEnterKeyPress';
import { Spinner } from '@app/dashboard/assets/icons';
import type { IForgetPasswordOtpStep } from '@app/dashboard/types/outerLayout/forget-password';
import { forgetPasswordVerifyOtp } from '@app/dashboard/services/outer_layout/forget-password';
import { registerResendOtp as forgetPasswordResendOtp } from '@app/dashboard/services/outer_layout/register';
import styles from "../forget-password.module.scss";


const SUBMIT_BTN_ID = 'forget-password-otp-submit-btn';

const OtpStep = (
  {
    loading,
    setLoading,
    setCurrentStep,
    STEPS,
    redirectToRegister
  }: IForgetPasswordOtpStep
) => {
  const { t } = useTranslation();
  useEnterKeyPress(SUBMIT_BTN_ID);

  const [otp, setOtp] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [serverErrMsg, setServerErrMsg] = useState('');
  const [serverSuccessMsg, setServerSuccessMsg] = useState('');
  const [otpResetTimerKey, setOtpResetTimerKey] = useState(0);

  useEffect(() => {
    setServerErrMsg("");
    setServerSuccessMsg("");
  }, [otp]);

  const onValidHandler = (valid: boolean) => {
    setIsValid(valid);
  };

  const onResendOTP = () => {
    setServerErrMsg("");
    setServerSuccessMsg("");
    setLoading(true);

    forgetPasswordResendOtp("forget-password")
      .then(() => {
        setOtpResetTimerKey(prevKey => prevKey + 1);
        setIsValid(false);
        setServerSuccessMsg(t('form.otpResent'));
      })
      .catch((error) => {
        const message = error.response?.data?.message;

        setServerErrMsg(message || t('errors.somethingWentWrong'));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleOtpSubmit = () => {
    setServerErrMsg("");
    setServerSuccessMsg("");
    setLoading(true);


    forgetPasswordVerifyOtp(otp)
      .then(() => {
        setCurrentStep(STEPS.RESET_PASSWORD);
      })
      .catch((error) => {
        const message = error.response?.data?.message;

        setServerErrMsg(message ? t('outerLayout.form.errors.wrongOtp') : t('errors.somethingWentWrong'));
      })
      .finally(() => {
        setLoading(false);
      });


  };

  return (
    <>
      <OTPStep
        loading={loading}
        otp={otp}
        setOtp={setOtp}
        otpResetTimerKey={otpResetTimerKey}
        onValid={onValidHandler}
        onResendOTP={onResendOTP}
        resendText={t('form.resendCodeIn')}
        resendBtnText={t('form.resend')}
        resendTimer={150}
        length={6}
      />
      <div className='form__submit'>
        {serverErrMsg && !serverSuccessMsg && <div className='form__submit__server-err'>{serverErrMsg}</div>}
        {serverSuccessMsg && !serverErrMsg && <div className='form__submit__server-success'>{serverSuccessMsg}</div>}

        <Button
          id={SUBMIT_BTN_ID}
          size='md'
          color='primary'
          variant='contained'
          text={loading ? undefined : t('outerLayout.form.next')}
          leadingIcon={loading ? Spinner : undefined}
          disabled={!isValid || loading}
          onClickHandler={handleOtpSubmit}
        />
      </div>

      <div className={styles["forget-password-form__dont-have-account"]}>
        <span className={styles["forget-password-form__dont-have-account__text"]}>{t('outerLayout.form.dontHaveAcc')}</span>
        <div className={styles["forget-password-form__dont-have-account__action"]}>
          <Button
            size='sm'
            color='primary'
            variant='link'
            text={t('outerLayout.form.signUp')}
            onClickHandler={redirectToRegister}
          />
        </div>
      </div>
    </>
  )
}

export default OtpStep;